import { render } from "./thankYouReject.vue?vue&type=template&id=2a34735a&scoped=true"
import script from "./thankYouReject.vue?vue&type=script&lang=js"
export * from "./thankYouReject.vue?vue&type=script&lang=js"

import "./thankYouReject.vue?vue&type=style&index=0&id=2a34735a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a34735a"]])

export default __exports__